export function ScoreRing({ value = 0, size = 120, stroke = 10, label = "Career Score", showLabel = true }) {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (v / 100) * c;
  const color = v >= 90 ? "#10B981" : v >= 60 ? "#1D4ED8" : "#F59E0B";
  return (
    <div className="inline-flex flex-col items-center" data-testid="score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
            strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 1s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-head font-bold text-slate-900" style={{ fontSize: size * 0.26 }}>{v}%</span>
        </div>
      </div>
      {showLabel && <span className="mt-2 text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</span>}
    </div>
  );
}
